module.exports = __webpack_public_path__ + "assets/img/25_417_big.b744ba19.jpg";